/**
 * Bluebox parity: required verzoek fields before "Verzenden naar Afas Profit" (modus auto).
 * @see bluebox Salary.js onSendAndSaveToAfas / manageSendAndSaveButton
 */

const isBlank = (value) =>
    value === null || value === undefined || String(value).trim() === '';

const valueInOptions = (value, options) => {
    if (!Array.isArray(options) || options.length === 0) {
        return !isBlank(value);
    }

    const needle = String(value);
    return options.some((option) => String(option.value ?? '') === needle);
};

/**
 * Vervangt is disabled in Bluebox when pool=Ja or vervangings d.v.b.=Nee.
 * When disabled it is not required (button enable + intended click check).
 */
export const isVervangtRequired = (verzoek = {}) => {
    if (String(verzoek.vervangerUitPool ?? '') === 'yes') {
        return false;
    }
    if (String(verzoek.vervangingsDvb ?? '') === 'no') {
        return false;
    }

    return true;
};

/**
 * @param {string} mode submit mode (auto|hand|afmelden)
 * @param {Record<string, unknown>} verzoek
 * @param {Record<string, Array<{value: string}>>} [optionsByField]
 * @returns {{ ok: boolean, missing: string[], message: string|null }}
 */
export const validateOpenstaandVerzenden = (
    mode,
    verzoek = {},
    optionsByField = {},
) => {
    if (mode !== 'auto') {
        return { ok: true, missing: [], message: null };
    }

    const missing = [];

    const check = (fieldId, label, { required = true } = {}) => {
        if (!required) {
            return;
        }
        const raw = verzoek[fieldId];
        if (isBlank(raw) || !valueInOptions(raw, optionsByField[fieldId])) {
            missing.push(label);
        }
    };

    check('financieringsbron', 'Financieringsbron');
    check('vervangt', 'Vervangt', { required: isVervangtRequired(verzoek) });
    check('kostenplaats', 'Kostenplaats');
    check('orgEenheid', 'Organisatorische eenheid');
    // Bluebox: only when field is enabled — Sunrise has no disable flag yet → always required
    check('aardArbeidsrelatie', 'Aard arbeidsRelatie');

    const vervangtChosen = isVervangtRequired(verzoek)
        && !isBlank(verzoek.vervangt)
        && String(verzoek.vervangt) !== '-1';
    if (vervangtChosen) {
        const verzuimOptions = optionsByField.verzuimVerlofId;
        if (!Array.isArray(verzuimOptions)) {
            missing.push('Verzuim-, verlof-id');
        } else if (verzuimOptions.length > 0) {
            check('verzuimVerlofId', 'Verzuim-, verlof-id');
        }
    }

    if (missing.length === 0) {
        return { ok: true, missing: [], message: null };
    }

    const message = [
        'Onderstaande velden mogen niet leeg zijn,',
        'of de gemaakte selectie bestaat niet.',
        '',
        'Maak eerst een bestaande selectie voor:',
        ...missing.map((label) => `- ${label}`),
    ].join('\n');

    return { ok: false, missing, message };
};
